import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'ramda'

import withStyle from './Paragraph.style.js'

const Paragraph = ({
  className,
  style,
  children,
  'data-testid': dataTestId,
}) => (
  <p style={style} className={className} data-testid={dataTestId}>
    {children}
  </p>
)

Paragraph.defaultProps = {
  size: 'default',
  doHeight: false,
  doMargins: false,
  verticalMargins: false,
  horizontalMargins: false,
}

Paragraph.propTypes = {
  /** Paragraph text */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  /** Paragraph optional className */
  className: PropTypes.string,
  /** Medium = default */
  size: PropTypes.oneOf(['large', 'default', 'medium', 'small', 'xsmall']),
  /** Font Weight : default is normal */
  weight: PropTypes.oneOf(['normal', 'bold']),
  /** Color : default is set by theme in styled component */
  color: PropTypes.string,
  /** Use the compouted height from getDimensions  */
  doHeight: PropTypes.bool,
  /** Use the compouted margins from getDimensions  */
  doMargins: PropTypes.bool,
  /** Either use the computed vertical margin from getDimersions (bool) or the value (with unit) passed in (string) */
  verticalMargins: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Either use the computed horizontal margin from getDimersions (bool) or the value (with unit) passed in (string) */
  horizontalMargins: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Inline styles */
  style: PropTypes.object,
  /** Test ID for targeting in automated tests */
  'data-testid': PropTypes.string,
  /** Light text for dark background */
  contrast: PropTypes.bool,
  /** Bold */
  bold: PropTypes.bool,
  /** Italics  */
  italic: PropTypes.bool,
}

export default compose(withStyle, memo)(Paragraph)
